export default "__VITE_ASSET__ChfxLUhS__"